import { actionTypes } from '../actions'
import { HYDRATE } from 'next-redux-wrapper'

const initialState = {
  agent: null,
  business: {},
  concept: '',
  copy: {},
  display_eta: null,
  display_special_instructions: null,
  feedback_completed: null,
  feedback_delay_minutes: null,
  feedback_enabled: null,
  feedback_questions: [],
  live_eta_time: null,
  geofence_dropoff: null,
  locations: [],
  order: {},
  order_channel_name: '',
  pusher: {},
  receipt_pdf_enabled: null,
  status: '',
  theme: {},
  tracking_hide_preparation_statuses: null,
  tracking_map_matching: null,
  page: 2,
}

function reducer(state = initialState, action) {
  // console.log("ORDER", state);
  // console.log("TYPE", action.type);
  // console.log("ACTION PAYLOAD", action.payload);
  switch (action.type) {
    case HYDRATE: {
      return { ...state, ...action.payload }
    }
    case actionTypes.FETCH_SUCCESS:
      return { ...state, ...action.payload }
    case actionTypes.FETCH_FEEDBACK_SUCCESS:
      return { ...state, ...{ feedback_questions: action.payload } }
    case actionTypes.THEME_REQUEST:
      return { ...state, themeLoading: true }
    case actionTypes.THEME_LOADED:
      return { ...state, ...action.payload, themeLoading: false }
    case actionTypes.THEME_UPDATED:
      return { ...state, theme: { ...state.theme, ...action.payload } }
    case actionTypes.UPDATE_ORDER:
      return { ...state, ...action.payload }
    case actionTypes.UPDATE_ETA:
      return { ...state, ...action.payload }
    case actionTypes.DRIVER_ARRIVAL_GEOFENCE_TRIGGERED:
      return { ...state, geofence_dropoff: true }
    case actionTypes.SET_LIVE_ETA:
      return { ...state, ...action.payload }
    case actionTypes.AGENT_CHANGED:
      // if (!action.payload.agent.agent_location) return state;
      const newAgent = action.payload

      if (newAgent === null) {
        return {
          ...state,
          agent: newAgent,
        }
      }

      const { agent_location } = newAgent
      return {
        ...state,
        agent: {
          ...state.agent,
          ...newAgent,
          ...(agent_location
            ? {
                agent_location: [
                  parseFloat(agent_location.latitude),
                  parseFloat(agent_location.longitude),
                ],
              }
            : {}),
        },
      }
    case actionTypes.UPDATE_AGENT:
      return {
        ...state,
        agent: {
          ...state.agent,
          ...{
            agent_location: [
              parseFloat(action.payload.latitude),
              parseFloat(action.payload.longitude),
            ],
          },
        },
      }
    case actionTypes.DEMO_MODE:
      return { ...state, ...{ page: action.payload } }
    default:
      return state
  }
}

export default reducer
